import React from "react";
import { ReactComponent as ShareScreenImage } from "../../assets/images/share-screen-illustion.svg";
import { ReactComponent as BulbIcon } from "../../assets/icons/svg/bulb.svg";
import { DEFAULT_FONT_FAMILY } from "../../config/fontConfig";

interface ScreenShareInstructionProps {
  isOpen: boolean;
  onClose: () => void;
  onDontShowAgain?: () => void;
  projectId: number;
}

const ScreenShareInstruction: React.FC<ScreenShareInstructionProps> = ({
  isOpen,
  onClose,
  onDontShowAgain,
  projectId,
}) => {
  if (!isOpen) return null;

  const handleDontShowAgain = () => {
    const dontShowAgainProjects = JSON.parse(
      localStorage.getItem("screen_share_instruction_dismissed") || "[]",
    );

    if (!dontShowAgainProjects.includes(projectId)) {
      dontShowAgainProjects.push(projectId);
      localStorage.setItem(
        "screen_share_instruction_dismissed",
        JSON.stringify(dontShowAgainProjects),
      );
    }

    if (onDontShowAgain) {
      onDontShowAgain();
    } else {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000]">
      <div className="bg-white rounded-xl shadow-2xl max-w-xl mx-4 overflow-hidden">
        {/* Header */}
        <div className="bg-white px-6 pt-4 pb-2">
          <div className="flex items-center gap-3">
            <BulbIcon className="w-5 h-5 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 4xl:w-8 4xl:h-8" />
            <h3
              className="text-[16px] 3xl:text-[18px] font-semibold  text-[#1E1F26]"
              style={{ fontFamily: DEFAULT_FONT_FAMILY }}
            >
              Pro tip
            </h3>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 pb-3">
          <p className="text-[#1E1F26] mb-6">
            <span
              className="text-[#6B87E6] font-semibold"
              style={{ fontFamily: DEFAULT_FONT_FAMILY }}
            >
              "Share window"
            </span>{" "}
            for better experience
          </p>

          <ShareScreenImage className="w-[450px] h-[180px]" />

          {/* Actions */}
          <div className="flex items-center justify-end gap-3 mt-6">
            <button
              onClick={handleDontShowAgain}
              className="text-sm text-[#1E1F26] transition-colors hover:text-gray-600"
              style={{ fontFamily: DEFAULT_FONT_FAMILY }}
            >
              Don't show again
            </button>
            <button
              onClick={onClose}
              className="bg-black text-white font-medium px-7 py-2 rounded-lg transition-colors hover:bg-gray-800"
              style={{ fontFamily: DEFAULT_FONT_FAMILY }}
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenShareInstruction;
